import { combineReducers } from "redux";
import login from 'state/ui/Login/LoginReducers';

export default combineReducers({ login });
